import React from 'react'
import PropTypes from 'prop-types'
import TextField from '@mui/material/TextField'
import Style from 'style-it'
import { useSelector } from 'react-redux';


const CustomTextField = (props) => {
	const themecolors = useSelector(state => state.themeColors)
	const cancelIconColor = encodeURIComponent(themecolors?.textColor || '#777');
    const cancelIconSvg = `url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' fill='${cancelIconColor}' viewBox='0 0 24 24'><path d='M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z'/></svg>")`;

    const { classes } = props

    const p = { ...props }

    delete p.dispatch

    return (
      <Style>
        {`
		.theme-label {
			margin-top: -10px;
			font-size: 12px;
			color: ${themecolors&&themecolors.textColor}
		}
.MuiInputBase-input.Mui-disabled,
.MuiSelect-select.Mui-disabled {
  -webkit-text-fill-color: ${themecolors?.textColor}CC !important;
  color: ${themecolors?.textColor}CC !important;
}



		.text-field-helper-text {
			color: inherit;
		}
		
		.theme-label-shrink {
			margin-top: 0
		}
		.theme-label-focused {
			margin-top: 0;
			 color: ${themecolors?.textColor} !important
		}
		.theme-textarea {
			font-size: 14px;
			padding: 0
		}
		.theme-label-error {
			color: ${themecolors&&themecolors.error}
		}
		.theme-notchedOutline-multiline,
		.theme-notchedOutline {
			border-color:  ${themecolors&&themecolors&&themecolors.themeLightColor} !important;
			border-radius: 4px;
			padding: 0;
		}
		.theme-input-error .theme-notchedOutline {
			border-color:  ${themecolors&&themecolors.error} !important;
		}
		.theme-cssFocused .theme-notchedOutline {
			border-color:  ${themecolors&&themecolors&&themecolors.themeLightColor} !important;
		}
		.theme-input-select {
			border-color: ${themecolors&&themecolors&&themecolors.themeLightColor};
			color: ${themecolors&&themecolors.textColor};
			padding: 0;
			display: flex;
            height: auto
        }
            .css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.Mui-disabled{
            -webkit-text-fill-color:${themecolors&&themecolors.textColor} !important;
            }
		.theme-textarea,
		.theme-input {
			border-color: ${themecolors&&themecolors&&themecolors.themeLightColor};
			color: ${themecolors&&themecolors.textColor};
			font-size: 12px;
			padding: 5px 7px 5px 14px;
			min-height: 18px
		}
		.menu-list-icon {
			color: ${themecolors&&themecolors.textColor};
		}
		.custom-paper {
			background-color: ${themecolors&&themecolors&&themecolors.themeLightColor};
		}
	`}
        <div style={{ display: 'flex', flex: 1 }}>
          <TextField
            margin='dense'
            {...p}
            variant='outlined'
            classes={classes}
            InputProps={{
              ...props.InputProps,
              classes: {
                root: 'theme-cssOutlinedInput',
                error: 'theme-input-error',
                input: props.multiline ? 'theme-textarea' : 'theme-input',
                focused: 'theme-cssFocused',
                multiline: 'theme-notchedOutline-multiline',
                notchedOutline: 'theme-notchedOutline'
              },
            }}
            FormHelperTextProps={{
              classes: { root: 'text-field-helper-text' }
            }}
            SelectProps={{
              MenuProps: {
                classes: {
                  paper: 'custom-menu-paper'
                }
              },
              classes: {
                icon: 'menu-list-icon'
              }
            }}
            InputLabelProps={{
              ...props.InputLabelProps,
              classes: {
                root: 'theme-label',
                focused: 'theme-label-focused',
                shrink: 'theme-label-shrink',
                error: 'theme-label-error'
              }
            }}
			sx={{
                  '& input[type="search"]::-webkit-search-cancel-button': {
                    WebkitAppearance: 'none',
                    height: '1.2rem',
                    width: '1.2rem',
                    marginLeft: '1em',
                    borderRadius: '50em',
                    background: cancelIconSvg,
                    backgroundSize: 'contain',
                    cursor: 'pointer',
                    zIndex: 1
                  }
                }}
          />
        </div>
      </Style>
    )
  }


CustomTextField.propTypes = {
  classes: PropTypes.object
}

 export default CustomTextField;